/**
 * 신청서 코드
 */
export default {
  Vacation: '22', // 근태
  BizTrip: '201', // 출장신청
  OtWork: '110', // 연장근무
  Schedule: '301', // 근무스케줄
  Attend: '30', // 출퇴근 변경
  Reward: '42', // 보상휴가
  CancelVacation: '23', // 근태 취소
  CancelReward: '43', // 보상휴가 취소
  EmpCerti: '11', // 재직증명서(한글)
  EmpCertiEn: '12', // 재직증명서(영문)
  CareerCerti: '13', // 경력증명서(영문)
  CareerCertiEn: '14', // 경력증명서(영문)
};
